import { render, staticRenderFns } from "./clientOption.vue?vue&type=template&id=28625d2e&"
import script from "./clientOption.vue?vue&type=script&lang=js&"
export * from "./clientOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports